// After a deploy the hashed chunks of the previous build are gone. A tab that stayed open then
// fails its next lazy import and shows the error page (DKT-90). Vite reports that failure as
// vite:preloadError; reload so the tab gets the new build. At most once a minute, so a chunk that
// is really missing ends up in the error boundary instead of a reload loop. The event is not
// cancelled: Vite would then resolve the import with nothing and the lazy route fails on
// "reading 'default'" before the reload. The import failure itself is on Sentry's ignore list.
// What browsers and Vite report for a chunk that vanished in a deploy; Sentry ignores these
// because the tab reloads itself
export const STALE_CHUNK_ERRORS = [
  /Failed to fetch dynamically imported module/, // Chrome
  /error loading dynamically imported module/, // Firefox
  /Importing a module script failed/, // Safari
  /Unable to preload CSS/, // Vite, a chunk's stylesheet
]

const KEY = "ppt_stale_chunk_reload"
const MIN_INTERVAL_MS = 60_000

type StaleChunkWindow = {
  addEventListener(type: "vite:preloadError", handler: () => void): void
  sessionStorage: Pick<Storage, "getItem" | "setItem">
  location: { reload(): void }
}

export const reloadOnStaleChunk = (win: StaleChunkWindow = window) => {
  win.addEventListener("vite:preloadError", () => {
    const now = Date.now()
    let last = 0
    try {
      last = Number(win.sessionStorage.getItem(KEY)) || 0
    } catch {
      // storage unavailable: reload anyway
    }
    if (now - last < MIN_INTERVAL_MS) return
    try {
      win.sessionStorage.setItem(KEY, String(now))
    } catch {
      // storage unavailable
    }
    win.location.reload()
  })
}
